export default __webpack_public_path__ + "static/media/7.56426ddc.jpg";